<script>
  import { layoutMethods, customerListLiteComputed, peddlrWalletKycLiteMethods, peddlrWalletKycLiteComputed,customerLiteMethods,peddlrWalletComputed } from "@/state/helpers";
  import Swal from 'sweetalert2';
  /**
   * Profile Header component
   */
  export default {
    page: {
      title: "Profile Header"
    },
    components: {
    },
    computed: {
      ...customerListLiteComputed,
      ...peddlrWalletKycLiteComputed,
      ...peddlrWalletComputed
    },
    data() {
      return {
        title: "Profile Header",
        removeCss: false,
        businessId:0,
        userKycPhotoUrl: {
          kycPhotos: {
            selfieUrl: null,
            idFrontPhotoUrl: null,
            idBackPhotoUrl: null,
            signatureUrl: null
          }
        },
        shuftiPhotoUrl: require('@/assets/images/users/user-placeholder.svg'),
        tempStoreCategory:"sss",
        storeCategoryOptiosn: [
          { text: 'Sari Sari Store', value: "sss" },
          { text: 'Non Sari Sari Store', value: "nsss" },
        ],
        secQueCurrentPage: 1,
        secQueRows: 0,
        secQuePageSize: 10,
        secQueFields: [
          { key: "requested_by", label: "Requested By", sortable: true},
          { key: "created_at", label: "Date and Time", sortable: true}       
        ]
      };
    },
    methods: {
      ...layoutMethods,
      ...peddlrWalletKycLiteMethods,
      ...customerLiteMethods,
      async fetchKycPhotos() {
        console.log("fetchKycPhotos: ")
        await this.getUserKycPhotos({
            businessId: this.businessId
        }).then(async () => {
            this.userKycPhotoUrl = this.userKycPhotos;
            console.log("GET RAW: ", this.userKycPhotos);
            if(this.userKycPhotos.kycPhotos.kycMethod!=undefined){
                await this.fetchUserShuftiPhoto();
            }
            
        }).catch((err) => {
            console.error("err", err);
        })
        if(this.businessDetails.subscriberId!=undefined){
          //await this.getUserKycStatus({userId: this.businessDetails.subscriberId});
        }
        
      },
      async fetchUserShuftiPhoto() {
        let kycMethod = this.userKycPhotoUrl.kycPhotos.kycMethod;
        let imgUrl = this.userKycPhotoUrl.kycPhotos.selfieUrl;

        // Peddlr Lite KYC is ONFIDO-only. Onfido already returns the selfie as a ready-to-use
        // "data:image/jpeg;base64,..." string, so use it directly. (Shufti returned a proof URL that
        // required an access-token POST to fetch the bytes — not used for Lite.)
        if (kycMethod === 'onfido') {
          this.shuftiPhotoUrl = imgUrl ? imgUrl : require('@/assets/images/users/user-placeholder.svg');
          return;
        }

        // Fallback for any other provider (e.g. a base64 data URL): use directly; otherwise placeholder.
        if (typeof imgUrl === 'string' && imgUrl.startsWith('data:')) {
          this.shuftiPhotoUrl = imgUrl;
        } else if (!imgUrl) {
          this.shuftiPhotoUrl = require('@/assets/images/users/user-placeholder.svg');
        }
      },
      openModal(modal=''){
        if (modal === 'bv-modal-store-category-edit') {
          this.tempStoreCategory = this.businessDetails?.storeCategory === 'Sari Sari Store' ? 'sss' : 'nsss';
        }
        this.$bvModal.show(modal);
      },
      closeModal(modal=''){
        this.$bvModal.hide(modal);
      },
      getValidationState({ dirty, validated, valid = null }) {
        return dirty || validated ? valid : null;
      },
      formatFigmaDate(value) {
        const formatted = value ? this.$options.filters.customFormatDate(value) : '';
        return formatted ? formatted.replace(/,?\s(?=\d{1,2}:\d{2}\s)/, ' at ') : '--';
      },
      loadSecQueHistory(){
        var userId = this.businessDetails.subscriberId;
        var params = { 
          userId: userId,
          page: this.secQueCurrentPage,
          pageSize: this.secQuePageSize
        }

        this.fetchSecQueHistory(params)
          .then((res) => {
            console.log('SECQUE:', res)
            this.secQueRows = res.message.rowCount
          })
      },
      openSecQueModal(){
        this.openModal('bv-modal-secque-logs');
        this.secQueCurrentPage = 1;
        this.loadSecQueHistory();
      },
      sendSecQueRequest(){
        var userId = this.businessDetails.subscriberId;
        var params = { userId: userId }
        
        Swal.fire({
          title: "Security Question Request",
          text: `Are you sure you want to send a security question to the merchant?`,
          icon: "info",
          showCancelButton: true,
          cancelButtonText: "Cancel",
          confirmButtonColor: "#e91e8c",
          cancelButtonColor: "#4a4a4a",
          confirmButtonText: "Yes",
        }).then((result) => {
          if (result.value) {
            this.sendSecQue(params)
              .then(() => {
                Swal.fire(
                  "Request Successful!",
                  `Security question has been successfully sent to the merchant.`,
                  "success"
                );
              })
              .catch(() => {
                Swal.fire({
                  title: "Request Failed",
                  text: `There was an issue sending the security question to the merchant. Please try again later.`,
                  icon: "warning",
                  showCancelButton: true,
                  cancelButtonText: "No",
                  confirmButtonColor: "#c4297c",
                  cancelButtonColor: "#804997",
                  confirmButtonText: "Yes",
                }).then((result) => {
                  if (result.value) {
                    this.sendSecQueRequest();
                  }
                });
              })
          }
        });
        
        
      },
      async submitChanges(){
        const currentStoreCategory = this.businessDetails?.storeCategory === 'Sari Sari Store' ? 'sss' : 'nsss';
        if(this.tempStoreCategory == currentStoreCategory){
          Swal.fire({
            title: "Saved Successfully",
            html: `Your selected ${this.$options.filters.readableStoreCategory(this.tempStoreCategory)} has been saved successfully.`,
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: '#804997',
            confirmButtonText: "OK",
          }).then((result) => {
            if (result.isConfirmed) {
              this.closeModal('bv-modal-store-category-edit');
            }
          });
          return;
        }
        await this.updateStoreCategory({
          businessId: this.businessDetails?.businessId,
          storeCategory: this.tempStoreCategory
        })
        .then((res)=>{
          console.log("><><>>>>>",res)
          Swal.fire({
            title: "Saved Successfully",
            html: `Your selected ${this.$options.filters.readableStoreCategory(this.tempStoreCategory)} has been saved successfully.`,
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: '#804997',
            confirmButtonText: "OK",
          }).then((result) => {
            if (result.isConfirmed) {
              this.closeModal('bv-modal-store-category-edit');
              // this.getBusinessDetailsv2({id: this.businessDetails.businessId});
            }
          });
        }).catch((e)=>{
          console.log("ERror:",e);
          Swal.fire("Failed!", e?.description || `Unable to update user's store cateogry`, "warning");
        })
      }
    },
    async mounted(){
      this.businessId = this.$route.params.bid
      await this.fetchKycPhotos();
    }
  }
    
</script>

<template>
  <div><!-- outer div-->
    <div class="card">
      <div class="card-body text-center">
          <div class="avatar-xl mx-auto mb-2" style="overflow: hidden;border-radius: 50%;border: 3px solid #dcdcdc;">
            <img
                :src="shuftiPhotoUrl"
              @error="
                (e) =>
                  (e.target.src = require('@/assets/images/users/user-placeholder.svg'), 
                  removeCss = true)
              "
              alt=""
              class="w-100"
          />
              <!-- :class="{'rounded-circle img-thumbnail' : !removeCss}" -->
          </div>
          <!-- <h5 class="mb-2 text-capitalize" @click="getUserKycPhotos">{{businessDetails.businessName}}</h5> -->
          <h5 class="mb-2 text-capitalize" @click="getUserKycPhotos">{{businessDetails.subscriberName}}</h5>
          <!-- <p class="text-muted small">Bussiness Name: <br/>MilkTea Gang</p> -->
      </div>

      <div class="border-top p-2 px-3">
          <div class="d-flex mb-2">
              <div class="flex-grow-1 my-auto">
                  <div class="">
                      <span class="align-middle fw-semibold">Store Category</span>
                  </div>
              </div>
              <div class="flex-shrink-0 my-auto">
                <b-link class="small fw-semibold text-primary" @click="openModal('bv-modal-store-category-edit')">Edit</b-link>
              </div>
          </div>
          <div class="mdr-custom mb-2">
            {{ (businessDetails?.storeCategory=='Sari Sari Store') ? 'sss' : 'nsss' | readableStoreCategory}}
          </div>
      </div>

      <div class="border-top p-3 px-3" v-if="peddlrWalletDetails.acct_no">
          <div class="d-flex">
            <div class="flex-grow-1 my-auto">
                <span class="align-middle fw-semibold">Security Question</span>
            </div>
            <div class="flex-shrink-0 my-auto">
                <button class="btn btn-primary btn-sm btn-send-secque" @click="sendSecQueRequest">Send</button>
            </div>
          </div>
          <div class="sec-que-text pt-3 pb-3">
            You can request the Netbank security question be sent via SMS to the merchant.
          </div>
          <div class="d-flex last-sent-request-txt">
            <div class="flex-grow-1 my-auto">
                <span class="align-middle fw-semibold">Last Request Sent:</span>
            </div>
            <div class="flex-shrink-0 my-auto">
                <a href="#" @click="openSecQueModal">View</a>
            </div>
          </div>
      </div>
    </div>


    <b-modal id="bv-modal-store-category-edit"
      size="md"
      centered
      hide-header
      hide-footer
      hide-header-close
    >

        <div class="text-center">
          <i class="text-info bx bx-info-circle" style="font-size: 90px;"></i>
          <h4 class="fw-semibold text-black my-3">Store Category</h4>
          <p>Please select a store category for this merchant:</p>
        </div>
        <ValidationObserver v-slot="{ handleSubmit, reset }">
          <b-form @submit.prevent="handleSubmit(submitChanges)" @reset.prevent="reset">
            <validation-provider name="MDR" rules="required" v-slot="validationContext">
              <div class="px-3 mb-4">
                  <label>Select Category</label>
                  <b-form-group>
                    <b-form-select class="form-select rounded-0 rounded-start shadow-none"
                      v-model="tempStoreCategory"
                      :options="storeCategoryOptiosn"
                      :state="getValidationState(validationContext)"
                    ></b-form-select>
                  </b-form-group>
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
              </div>
            </validation-provider>
            <div class="text-center">
              <b-button
                type="button"
                variant="dark"
                @click="closeModal('bv-modal-store-category-edit')"
                class="me-2"
              >
                Cancel
              </b-button>
              <b-button
                type="submit"
                variant="primary"
              >
                Save
              </b-button>
            </div>
          </b-form>
        </ValidationObserver>
    </b-modal><!--bv-modal-mdr-update-->

    <b-modal id="bv-modal-secque-logs" title="Last Request Sent" size="lg" centered hide-footer hide-header-close no-close-on-backdrop>
      <div class="table-responsive">
        <div class="table align-middle table-nowrap">
          <b-table
            :items="secQueHistory"
            :fields="secQueFields"
            responsive="sm"
            class="table-check"
            show-empty
          >
            <template #cell(requested_by)="data">
              <p class="text-body m-0">{{ data.item.requested_by }}</p>
            </template>
            <template #cell(created_at)="data">
              <p class="text-body m-0">{{ formatFigmaDate(data.item.created_at) }}</p>
            </template>
            <template #empty="">
              <div class="text-center w-100">No data to display.</div>
            </template>
          </b-table>
          <b-pagination
            v-if="secQueRows > secQuePageSize"
            align="right"
            class="pagination-rounded"
            v-model="secQueCurrentPage"
            :total-rows="secQueRows"
            @input="loadSecQueHistory()"
            :per-page="secQuePageSize"
          ></b-pagination>
        </div>
      </div>
      <div class="text-end mt-3 mb-1">
        <b-button class="w-sm"
                  type="button"
                  variant="light"
                  @click="closeModal('bv-modal-secque-logs')"
                  >Close
        </b-button>
      </div>
    </b-modal>

  </div> <!-- end of outer div-->
</template>

<style>
.btn-send-secque {
  width: 80px;
  height: 25px;
  padding: 2px;
}

.sec-que-text {
  color: #000;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px; /* 140% */
}

.last-sent-request-txt {
  font-size: 13px;
}
</style>